import LoaderPage from '@/shared/components/loaders/LoaderPage';
import { Outlet, useNavigation } from 'react-router-dom';

/**
 * Layout para rutas públicas accesibles sin autenticación.
 *
 * Funcionalidad:
 * - Proporciona una estructura minimalista para páginas de acceso público (login, etc.)
 * - Diseño sin navbar ni header para experiencia de usuario limpia
 * - Maneja estados de carga durante transiciones de navegación
 *
 * Responsabilidades:
 * - Renderizar contenido dinámico mediante React Router Outlet
 * - Detectar y mostrar LoaderPage durante navegación entre rutas públicas
 * - Mantener estructura de pantalla completa sin elementos de navegación
 */
const PublicLayout = () => {
  const navigation = useNavigation();
  const isNavigating = navigation.state === 'loading';

  return (
    <div className="relative flex flex-col gap-2 h-screen">
      <main className="relative w-full h-full">
        <Outlet />
      </main>

      {isNavigating && <LoaderPage />}
    </div>
  );
};

export default PublicLayout;
